import { btNuggetsColumn } from "../resource/bt-nuggets-column";
import { NeededColumn } from "./needed-column";

export const btNuggetNeededColumn = new NeededColumn(
  "902f0db5-87da-496c-a232-afbb325211c0",
  btNuggetsColumn,
  "Black Nug Needed"
)
